import { Button } from '@/components/button';
import HeadlineField from '@/components/customFields/HeadlineField';
import { HeadlineTag } from '@/components/customFields/types';
import ProductCardBenefitsList from '@/components/productCardBenefitsList/ProductCardBenefitsList';
import type { TrackingInformation } from '@/helper/tracking';
import type { B2BTariff } from '@/storyblok/pageB2B/B2BTariffOverview';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import classes from './B2BProductCard.module.scss';

export interface B2BProductCardProps {
  tariff: B2BTariff;
  onSelectTariff: () => void;
  onDeselectTariff: () => void;
  trackingInfos?: TrackingInformation;
  activeTariff?: boolean;
  pricePlaceholder: string;
  className?: string;
}

export const B2BProductCard: React.FC<B2BProductCardProps> = ({
  tariff,
  onSelectTariff,
  onDeselectTariff,
  trackingInfos,
  activeTariff,
  pricePlaceholder,
  className,
}) => {
  const active = activeTariff;
  const { t } = useTranslation();

  return (
    <div className={classNames(classes.productCard, className, { [classes.active!]: active })}>
      <HeadlineField tag={HeadlineTag.H3} style={HeadlineTag.H5} className={classes.title}>
        {tariff.tarifname}
      </HeadlineField>
      <div className={classes.division}>
        <div className={classes.price}>
          <div className={classes.priceHeading}>Energiepreis</div>
          <div>{tariff.showPrice ? tariff.price.replace('.', ',') : pricePlaceholder}</div>
          <div className={classNames(classes.priceUnit, { 'hide-opacity': !tariff.showPrice })}>ct/kWh</div>
        </div>
      </div>
      <ProductCardBenefitsList
        benefits={[
          {
            label: `${tariff.duration} Monate Vertragslaufzeit`,
          },
        ]}
        size={'small'}
      />
      {active ? (
        <Button data-testid="deselect-tariff-button" variant="ctaWhite" onClick={() => onDeselectTariff()}>
          {'Tarif abwählen'}
        </Button>
      ) : (
        <Button data-testid="select-tariff-button" variant="ctaFull" onClick={() => onSelectTariff()}>
          {t('productCard.labelChooseTariff')}
        </Button>
      )}
    </div>
  );
};

export default B2BProductCard;
